<ion-grid class="ion-no-padding">
  <ion-row>
    <ng-container
      *ngFor="
        let product of productosPromocion;
        let last = last;
        trackBy: trackByProduct
      "
    >
      <!-- * Fila de producto individual -->

      <ion-col size="12" class="product-card">
        <ion-grid class="ion-no-padding">
          <ion-row class="ion-justify-content-between">
            <!-- ? Columna de imagen -->

            <ion-col size="1.7" class="product-image-container">
              <ion-img
                [src]="product.imagen"
                class="product-image"
                [alt]="product.title"
              ></ion-img>
            </ion-col>

            <!-- ? Columna de contenido -->

            <ion-col size="5.8">
              <ion-label>
                <p class="product-title">
                  {{ product.title }}
                </p>

                <p class="product-subtitle">
                  {{ product.subtitle }}
                </p>

                <p class="product-details">
                  {{ 'Labels.taste' | translate }}:&nbsp;{{ product.sku }}
                </p>

                <ng-container *ngIf="!isSKUFactorCl">
                  <p class="product-details">
                    {{ 'Labels.sku' | translate }}:&nbsp;{{
                      product.clave_producto
                    }}

                    <b>
                      {{ 'Labels.factorcl' | translate }}:

                      {{ product.FactorCl }}
                    </b>
                  </p>
                </ng-container>
              </ion-label>
            </ion-col>

            <!-- ? Columna de acciones (precio y botón) -->

            <ion-col
              size="3.9"
              class="ion-align-self-center"
              [ngClass]="
                tipoPromocion !== 'BONIFICACION'
                  ? 'ion-text-center'
                  : 'ion-text-end'
              "
            >
              <!-- * Precios -->

              <ion-label color="getm-neutral-dark" class="product-price">
                <ng-container
                  *ngIf="tipoPromocion !== 'BONIFICACION'; else priceBoni"
                >
                  <del
                    class="reduction"
                    *ngIf="product.precio_original !== product.precio"
                  >
                    {{
                      product.precio_original
                        | currency : undefined : 'symbol' : '1.2-2'
                    }}
                  </del>

                  &nbsp;

                  {{
                    product.precio | currency : undefined : 'symbol' : '1.2-2'
                  }}
                </ng-container>

                <ng-template #priceBoni>
                  {{
                    product.precio | currency : undefined : 'symbol' : '1.0-0'
                  }}
                </ng-template>
              </ion-label>

              <!-- * Botón agregar -->

              <section @fadeSlide>
                <ng-container *ngIf="product.productos < 1">
                  <getm-button
                    [text]="'Buttons.add' | translate"
                    color="tertiary"
                    size="default"
                    expand="block"
                    [disabled]="disabled"
                    (btnClick)="onQuantityChange(product, 1)"
                  ></getm-button>
                </ng-container>

                <!-- * Selectores de cantidad -->

                <ng-container *ngIf="product.productos >= 1">
                  <getm-quantity-selector
                    [quantity]="product.productos"
                    [minimo]="1"
                    [maximo]="
                      disabled
                        ? product.Minimo
                        : maximo
                        ? maximo
                        : product.Maximo
                    "
                    (quantityChange)="onQuantityChange(product, $event)"
                    (removeProduct)="onRemoveProduct(product)"
                  ></getm-quantity-selector>
                </ng-container>
              </section>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>

      <!-- * Línea separadora (solo si no es el último) -->

      <ion-col size="12">
        <hr class="product-separator" />
      </ion-col>
    </ng-container>
  </ion-row>
</ion-grid>
